import React from 'react';
import { Button } from 'react-bootstrap';
import './NavButtons.css';


interface NavButtonsProps {
    style?: React.CSSProperties;
    backButtonText?: string;
    nextButtonText?: string;
    disabled?: boolean,
    handleBack: () => void;
    handleNext: () => void;
    onDisabledClick?: () => void;
}

const NavButtons = ({
    style = {},
    backButtonText = "Back",
    nextButtonText = "Next",
    disabled = false,
    handleBack,
    handleNext,
    onDisabledClick = () => { },
}: NavButtonsProps) => {
    return (
        <nav
            className="navigation-buttons"
            style={style}
        >
            <div
                className='back-button'
                onClick={handleBack}
            >
                {backButtonText}
            </div>
            <div onClick={() => {
                if (disabled) {
                    onDisabledClick();
                } else {
                    handleNext();
                }
            }}>
                <Button
                    className="button-accent"
                    disabled={disabled}
                >
                    {nextButtonText}
                </Button>
            </div>
        </nav>
    );
}

export default NavButtons;